import { ShoppingCartService} from "@/services/ShoppingCartService"

const state = {
    cart: {},
    cartSummary: {}
}

const getters = {
    cart: state => state.cart,
    cartSummary: state => {
        return state.cartSummary
    }
}

const mutations = {
    SET_CART: function(state, cart) {
        state.cart = cart
    },
    SET_CART_SUMMARY: function(state, cartSummary) {
        state.cartSummary = cartSummary
    }
}

const actions = {
    LOAD_CART: ({commit, dispatch}, args) => {
        ShoppingCartService.GetShoppingCart(args).then( result => {
            commit("SET_CART", result)
        })
    },
    LOAD_CART_SUMMARY: ({commit, dispatch}, args) => {
        ShoppingCartService.GetShoppingCartSummary(args).then( result => {
            commit("SET_CART_SUMMARY", result)
        })
    }
}

export default {
    getters,
    mutations,
    actions,
    state
}
